// @flow
import styled, { css } from "styled-components";

import buildColor from "../../_static/ColorPalette";

export const RaceAlertsRow = styled.div`
  height: 40px;
  padding: 12px 8px;
  background-color: ${buildColor("white", "100")};
  color: ${buildColor("grey", "900")};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  ${(props) =>
    props.topBorder &&
    css`
      border-top: 1px solid ${buildColor("grey", "300")};
    `};
  ${(props) =>
    props.bottomBorder &&
    css`
      border-bottom: 1px solid ${buildColor("grey", "300")};
    `};

  > div {
    align-items: center;
    display: flex;
  }
`;

export default { RaceAlertsRow };
